import { useApiQuery } from "app/modules/api-client";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { IIndustryDataAvailabilityState } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import type { PerformanceResponse } from "../../types";
import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

interface IIndustryAdPlacementData {
    placement: PerformanceResponse["placements"];
    startDate: string;
}

interface IUseIndustryAdPlacementResult {
    data?: IIndustryAdPlacementData;
    isLoading: boolean;
    isError: boolean;
    availability: IIndustryDataAvailabilityState;
}

export const useIndustryAdPlacement = (category: IFlattenedCategory): IUseIndustryAdPlacementResult => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustryAdPositionList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustryAdPositionList",
            options: {
                enabled: !availability.isFullyUnavailable,
                select: (response) => ({
                    placement: {
                        above: response?.aboveTheFold,
                        below: response?.belowTheFold,
                        farBelow: response?.farBelowTheFold,
                    },
                    startDate: response?.startDate,
                }),
            },
        },
        params,
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
